import React, {useContext, useEffect} from 'react';
import {Button, Space} from 'antd';
import {observer} from "mobx-react";
import {CardStyled} from "../../../components/styled/card.styled";
import {StoreContext} from "../../../store.context";
import * as Agency from "../../../modules/agency";
import {ButtonBar} from "../../../builder";
import {Translate} from "../../../components/util/translation.util";
import {useNavigate} from "react-router-dom";
import AccessUtil from "../../../components/util/access.util";
import {TranslationDomainEnum} from "../../../types/enums";
import {Helmet} from "react-helmet-async";

export const List: React.FC = observer(() => {
    const { appStore: {
        moduleStore: {
            agencyStore: {
                setTableFilterData,
                list
            },
        },
            translate
    } } = useContext(StoreContext);

    const translationDomain = TranslationDomainEnum.COMPANY_ADMINISTRATION;
    const title = translate('agency.title.agencies', {}, translationDomain);

    const navigate = useNavigate();
    const onSubmit = (values: any) => {
        setTableFilterData && setTableFilterData(values);
        list();
    };

    useEffect(() => {
        list();
    }, [list])

    return (
        <React.Fragment>
            <Helmet>
                <title>{`CL BO - ${title}`}</title>
            </Helmet>
            <Space direction="vertical" size="small" style={{ display: 'flex' }}>
                <Agency.FilterForm onSubmit={onSubmit} onReset={() => onSubmit([])} />

                <CardStyled title={<Translate message={`global.title.search_results`} />}>
                    <Agency.FilterTable />
                </CardStyled>
            </Space>
            <AccessUtil access={{ routeName: 'agency_add', attributes: [] }}>
                <ButtonBar>
                    <Button type="primary" htmlType={`button`} onClick={() => {
                        navigate("/agency/add");
                    }}><Translate message={`global.button.add`} /></Button>
                </ButtonBar>
            </AccessUtil>
        </React.Fragment>
    )
})